<div class="payment">
  <div class="info">
    <span class="codigo">
      <small>À vista: </small>
      {{ payment?.aVista ? "Sim" : "Não" }}
    </span>
    <span class="descricao">
      <small>Meio: </small>
      {{ payment?.descricaoMeio }}
    </span>
    <span class="valor">
      <small> Valor: </small>
      {{ payment?.valor | currency: "BRL" }}
    </span>
  </div>
  <div class="menu">
    <p-speedDial
      [model]="options"
      [radius]="40"
      direction="up-left"
      [id]="payment?.id"
      type="quarter-circle"
    ></p-speedDial>
  </div>
</div>
